module.exports = __webpack_public_path__ + "static/media/icon.1e745f94.svg";